import { createFromBaseTheme } from "@/style/baseTheme";
import { createTheme, ThemeOptions } from "@mui/material";
import logo from '/images/logo.png'
import logoBar from '/images/logoBar.png'

const customConstants: ThemeOptions = {
  palette: {
    primary: {
      main: "#F52B1D",
    },
    secondary: {
      main: "#E6E6E6",
    }
  },
  custom: {
    constants: {
      logoImage: logo,
      logoBarImage: logoBar,
    }
  }
};

const baseCustomizedTheme = createFromBaseTheme(customConstants);

const customizations: ThemeOptions = {}

const newTheme = createTheme(baseCustomizedTheme, customizations);

export default newTheme;
